import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../middleware/api';
import {UserDto} from '../dto/UserDto';
import {ProfileDto} from '../dto/ProfileDto';

export const fetchUser = createAsyncThunk('auth/fetchUser', async () => {
    const response = await Api.fetch({endpoint: 'users/me', method: ApiMethods.GET});
    if (response.httpStatus === 200) {
        return response.responseData as UserDto;
    } else {
        throw new Error();
    }
});

export const fetchUserProfile = createAsyncThunk('auth/fetchUserProfile', async (_, {dispatch, getState, extra}) => {
    const user = (await fetchUser()(dispatch, getState, extra)).payload as UserDto;
    const response = await Api.fetch({endpoint: `profiles/${user.profileId}`, method: ApiMethods.GET});
    if (response.httpStatus === 200) {
        return response.responseData as ProfileDto;
    } else {
        throw new Error();
    }
});

export const clearUser = createAction('auth/clearUser');
